import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

import 'assets/scss/popover.scss'
import 'assets/scss/SolicitudesPermisos.scss'
import * as reactTable from 'react-table';
import { HistorialSolicitudesTH } from './TyperHistorialAprobaciones'
import { Popover } from './Popover';


export default function TablaHistorialNotificadoth({ dataFilas, onClickVerDocumento, anioSeleccionado, onChangeAnio, onClickVerMotivo}) {

    const [anioMostrado, setanioMostrado] = useState(anioSeleccionado);

    const [popoverRef, setPopoverRef] = useState<any>(null);
    const [selectedRow, setSelectedRow] = useState<reactTable.Row<HistorialSolicitudesTH> | null>(null);
    const iconRef = useRef(null);

    const CellFechaDetalle = (totalrow: reactTable.Row<HistorialSolicitudesTH>) => {

        const { original, index } = totalrow
        const row = { ...original }
        const fecha = row.fechavthnega ? ObtenerFechaFromIsoFormat(row.fechavthnega.toString()) : "";


        if (row.fechavthnega) {
            return (
                <div className="containerFechaDetalle" key={`containerFechas ${index}`}>
                    {fecha}
                    <i ref={iconRef} onClick={(e) => {
                        e.stopPropagation();
                        setPopoverRef(e.currentTarget);
                        setSelectedRow(totalrow);
                    }} className="fa fa-solid fa-ellipsis-vertical hoverable"></i>

                </div>
            );
        }
        else {
            return (
                <span>{fecha}</span>
            );
        }

    }  

    function GenerarCellDocumentos(data: reactTable.Row<HistorialSolicitudesTH>) {

        const { original, index } = data
        const row = { ...original }

        const iconoDescargarEvidencia = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Evidencia"
                onClick={() => onClickVerDocumento(row.evidencia)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Evidencia"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Evidencia"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                onClick={() => onClickVerDocumento(row.solicitud)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )        

        const contentAccion = (
            <React.Fragment>
                {row.evidencia && iconoDescargarEvidencia}
                {row.solicitud && iconoDescargarSolicitud}

            </React.Fragment>
        )
        return contentAccion
    }

    function GenerarCellAcciones(data) {        
        const iconoObservarComentario = (
            <span>
                <i className="fa fa-solid fa-message verDetalleHistorialSolicPer ml-2" title="Ver motivo del rechazo" onClick={() => onClickVerMotivo(data.acciones)}></i>
            </span>
        )

        const contentAccion = (
            <React.Fragment>
                {(data.acciones.motivo !== "" && data.acciones.estadoPermiso === "E") && iconoObservarComentario}
            </React.Fragment>
        )
        return contentAccion
    }

    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )

    const columnas: any = React.useMemo(
        () => [
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Tipo Permiso/Licencia',
                accessor: 'tipoPermiso'
            },
            {
                Header: 'Identificación',
                accessor: 'identificacion'
            },
            {
                Header: 'Nombres',
                accessor: 'nombres'
            },
            {
                Header: 'Régimen',
                accessor: 'siglasRegimen',
            },
            {
                Header: 'Fecha Desde',
                accessor: 'fechaInicio',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Fecha Hasta',
                accessor: 'fechaFin',
                Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
            },
            {
                Header: 'Días',
                accessor: 'tiempo',
            },
            {
                Header: 'Horas',
                accessor: 'horasDif',
            },            
            {
                Header: 'Estado Solicitud',
                accessor: 'estadoParse',
            },
            {
                Header: 'Fechas',
                accessor: 'fechavthnega',
                Cell: ({ row, }) => {

                    return CellFechaDetalle(row)
                }
            },
            {
                Header: "Documentos",
                accessor: (row) => ({
                    documentos: row,
                }),
                Cell: ({ row }) => {
                    return GenerarCellDocumentos(row)
                }
            },
            {
                Header: "Observaciones",
                accessor: (row) => ({
                    acciones: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            },

        ], [dataFilas]
    )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
        {
            HeaderName: 'Identificación',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Régimen',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Solicitud',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Estado Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Desde',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fecha Hasta',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Días',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Horas',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Fechas',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Documentos',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Observaciones',
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    const closePopover = () => {
        setPopoverRef(null);
        setSelectedRow(null);
    };    

    const PopOverFecha = (row: HistorialSolicitudesTH) => {
        // Datos organizados en un array para mejor manejo
        const items = [
            {
                label: 'Negada Parcialmente TH',
                fecha: row.fechavthnega,
                nombre: row.analista,
                condition: !!row.fechavthnega
            },
            // ... añadir el resto de los items de la misma forma
        ];

        return (
            <ul className="listadoPopOver">
                {items.map((item, index) => (
                    (item.condition === undefined || item.condition) && (
                        <li key={index}>
                            <span>{item.label}</span>
                            <span>{item.fecha ? ObtenerFechaFromIsoFormat(item.fecha.toString()) : ""}</span>
                            <span>{item.nombre || ""}</span>
                        </li>
                    )
                ))}
            </ul>
        );
    };    
    function HandleChangeAnioOnTable(anioSeleccionado) {
        if (typeof (anioSeleccionado) === "number") {
            setanioMostrado(anioSeleccionado.toString())
        }
        onChangeAnio(anioSeleccionado)
    }

    const BotonDescargarReporte = useMemo(() => {

        const URLAnios = "AprobacionTh/HistorialSolicitudesEstadoNotificado/AniosDisponibles";

        const URLREPORTE = "AprobacionTh/HistorialSolicitudesEstadoNotificado/Reporte"

        if (anioSeleccionado !== undefined) {

            const anioForButton = +anioSeleccionado

            return (
                <ButtonDownloadReportTable
                    api={URLREPORTE}
                    nombreBoton='Reporte Historial Solicitudes Pendientes de Regularización'
                    apiYears={URLAnios}
                    onChangeYearNotAsync={HandleChangeAnioOnTable}
                    yearElegido={anioForButton}
                />
            )
        }

    }, [anioSeleccionado])

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />

                    </div>
                </Col>
            </Row>
            <Row className="justify-content-end mb-1">
                <Col xl={3} lg={3} md={4} sm={12}>
                    {BotonDescargarReporte}
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>

            {popoverRef && selectedRow && (
                <Popover referenceElement={popoverRef} onClose={closePopover} showBackdrop={true}>
                    <div className={"arrowStyle"}></div> {/* Esta es la punta */}
                    {PopOverFecha(selectedRow.original)}
                </Popover>
            )}           
        </React.Fragment>
    )
}